<!-- ikids/kids-class
class dashboard
teacher page -->

<template>
  <div class="wrapper">
    <CRow>
      <CCol>
        <div class="card">
          <div class="card-body">
            <CRow>
              <CCol lg="6" >
                <div id="app">
                  <CRow>
                    <CCol>
                      <h5 class="d-flex justify-content-start">{{currentDate()}}</h5>
                    </CCol>
                    <CCol>
                      <h5 class="d-flex justify-content-end"> {{ showTime }} </h5>
                    </CCol>
                  </Crow>
                </div>
              </CCol>
            </CRow>
          </div>
        </div>
      </CCol>
    </CRow>
      <Crow>
        <CCol >
          <Datatable
          :listclass="listclass"
          :meta="meta"
          @search="handleSearch"
          @status_filter="handleStatus"
          @class_filter="handleClassFilter"
        />
      </CCol>
    </Crow>
    <CRow class="card-set">
          <CCol lg="4" v-for="item in items" :key="item.id" >
            <CCol  >
              <CCard class="card">
                <CRow>
                  <CCol>
                    <CCardBody>
                      <CRow>
                        <img v-if="item.profilepic !== null" v-bind:src="getPhoto(item.get_photo)" class="c-avatar-img-kids justify-content-start">
                          <CCol>
                            <CCallout v-if="item.checkin_status == null" color="secondary">
                          <row >
                            <h5><CBadge v-if="item.checkin_status == null" color="secondary">Unconfirmed</CBadge></h5>
                            <p> <b> {{item.name}} </b></p>
                            <p> Class: <b>{{item.class_name}} </b> </p>
                            <p hidden> Date Of Birth: <b>{{item.dob}} </b> </p>
                          </row>
                        </CCallout>
                        <CCallout v-else-if="item.checkin_status !== null && item.checkin_status == 'in queued'" color="warning">
                          <row >
                            <h5><CBadge v-if="item.checkin_status !== null && item.checkin_status.action == 'queued'" color="warning">In Queued</CBadge></h5>
                            <p>  <b> {{item.name}} </b></p>
                            <p> Class: <b>{{item.class_name}} </b> </p>
                            <p hidden> Date Of Birth: <b>{{item.dob}} </b> </p>
                          </row>
                        </CCallout>
                        <CCallout v-else="item.checkin_status !== null && item.checkin_status == 'in class'" color="success">
                          <row >
                            <h5><CBadge v-if="item.checkin_status !== null && item.checkin_status.action == 'in class'" color="success">In Class</CBadge></h5>
                            <h5><CBadge v-if="item.checkin_status !== null && item.checkin_status.action == 'queued'" color="warning">In Queued</CBadge></h5>
                            <h5><CBadge v-if="item.checkin_status !== null && item.checkin_status.action == 'check out'" color="warning">Check Out</CBadge></h5>
                            <p>  <b> {{item.name}} </b></p>
                            <p> Class: <b>{{item.class_name}} </b> </p>
                            <p> Time: <b>{{ formatTime(item.checkin_status.log_time) }} </b> </p>
                            <p hidden> Date Of Birth: <b>{{item.dob}} </b> </p>
                            <CButton  v-if="item.checkin_status !== null && item.checkin_status.action == 'queued' && (item.class_name == 'Incredible' || item.class_name == 'Super' || item.class_name == 'Wonder')" block @click=" openCheckOut(item.id)"  variant="primary" color="danger">Check Out</CButton>
                          </row>
                        </CCallout>
                      </CCol>
                    </CRow>
                  </CCardBody>
                </CCol>
              </CRow>
            </CCard>
          </CCol>
        </CCol>
    </CRow>
      <ikidmodal_checkin></ikidmodal_checkin>
      <alertmodal></alertmodal>
  </div>
</template>

<script >
import Datatable from '@/components/datatables_ikid_class.vue'
import DatatableClass from '@/components/datatables_ikid_check_class.vue'
import DatatableLog from '@/components/datatables_ikid_check_log.vue'

import axios from 'axios'

import ikid from '@/services/ikid'
import ikidmodal_checkin from './ikidsmodal_checkin.vue';

import alertmodal from '@/views/alert/modal.vue';
import EventBus from '@/eventBus';
import store from '@/store.js'

import Pusher from 'pusher-js';
import Vue from 'vue'
import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'

export default {
  name: 'iKidsTable',
  components: { ikidmodal_checkin, alertmodal, Datatable,DatatableClass,DatatableLog },
  data(){
    const url = window.location.href;
    const index = url.indexOf('class=')
    let ikid_class_name = url.slice(index).split('=')[1] || ""

    //buat 1 kata class name menjadi huruf besar
    ikid_class_name = ikid_class_name.charAt(0).toUpperCase() + ikid_class_name.slice(1)
    return{
      form:{
        ikid_id:'',
        status:'',
        from:'portal',
      },
      showMilitary: false,
      showTime: '',
      now: new Date(),
      updateSubmit: false,
      largeModal:false,
      datas:[],

      //start
      fields: [
          {key: 'name', sortable: false, },
          {key: 'profilepic', sortable: false, },
          {key: 'class_name', sortable: false, },
          {key: 'checkin_status', label:'Status', sortable: false, },
      ],
      rawItems: [],
      items: [],
      listclass: [],
      meta: [],
      current_page: 1,
      per_page: 200,
      search: '',
      sortBy: 'checkin_status',
      sortByDesc: true,
      is_active: 1,
      permission: true,
      ikid_class_name: ikid_class_name || 0,
      kid_class_id : '',
      checkin_status: 2,
      check_status : 2,
      pusher_data: {
        kid_name: null,
        kid_class_id: null,
        now_action: null,
        from: null,
      },
      arr_check_status: [],
      refreshTimer: null,
      refreshQueued: false,
      refreshInFlight: false,
      refreshLastRunAt: 0,
      refreshIntervalMs: 2500,
      pusherClient: null,
      lastEventId: null
      //end
    }
  },

  created() {
      //this.loadData()
      this.beforeDestroy()

      // fill arr constant
      this.arr_check_status[1] = 'check in';
      this.arr_check_status[2] = 'in class';
      this.arr_check_status[3] = 'queued';
      this.arr_check_status[4] = 'check out';
  },

  async mounted (){
    await this.loadClass()
     this.loadData()

    EventBus.$on('TABLE_UPDATE_KIDS_CLASS_TEACHER', (data) => {
      if(data){
          this.loadData();
      }
    });
    this.showTheTime()

    // PUSHER START
    Vue.use(Toast)
    this.pusherClient = new Pusher('fbb60f501f4a91119030', {
      cluster: 'ap1',
      encrypted: true
    });
    const channel = this.pusherClient.subscribe('kid-channel');
    channel.bind('status-change', (data) => {
      this.pusher_data.kid_name = data.kid_name
      this.pusher_data.kid_class_id = data.kid_class_id
      this.pusher_data.now_action = data.now_action
      this.pusher_data.from = data.from

      if (this.kid_class_id == data.kid_class_id || this.kid_class_id == 0) {
        this.queueRealtimeRefresh(true);
      }
    });
    channel.bind('status-cancel', (data) => {
      this.pusher_data.kid_name = data.kid_name
      this.pusher_data.kid_class_id = data.kid_class_id
      this.pusher_data.now_action = data.now_action
      this.pusher_data.from = data.from

      this.queueRealtimeRefresh(false);
    });
    // PUSHER END


   },

  beforeDestroy() {
    if (this.refreshTimer) {
      clearTimeout(this.refreshTimer)
      this.refreshTimer = null
    }
    if (this.pusherClient) {
      this.pusherClient.disconnect()
      this.pusherClient = null
    }
  },

  methods: {
    beforeDestroy(){
    EventBus.$off('OPEN_MODAL_IKID_CHECKIN', this.listener)
    EventBus.$off('OPEN_MODAL_IKID_QUEUE', this.listener)
    EventBus.$off('OPEN_MODAL_IKID_CHECKOUT', this.listener)
   },
   currentDate() {
    var  months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

      const current = new Date();
      const date = current.getDate() +' '+ months[current.getMonth()]+' '+current.getFullYear()
      return date;
    },
   showTheHours(theHour) {
      var vm = this
      if (vm.showMilitary|| (theHour > 0 && theHour < 13)) {
        if (theHour == "") theHour = 12;
        return (theHour);
      }
      if (theHour == 0) {
        return (12);
      }
      return (theHour);
    },
    showZeroFilled(inValue) {
      if (inValue > 9) {
        return "" + inValue;
      }
      return "0" + inValue;
    },
    showAmPm() {
      var vm = this
      if (vm.showMilitary) {
        return ("");
      }
      if (vm.now.getHours() < 12) {
        return (" AM");
      }
      return (" PM");
    },

    showTheTime() {
      var vm = this
      vm.now = new Date
      vm.showTime = vm.showTheHours(vm.now.getHours()) + ":" + vm.showZeroFilled(vm.now.getMinutes()) + ":" + vm.showZeroFilled(vm.now.getSeconds()) + vm.showAmPm()
      setTimeout(vm.showTheTime,1000)
    },
    openShow() {
         var params = { title: "Scan Kids" };
         this.$router.push({ name: "Kids Scan" });
      },

    async loadClass(){
      await ikid.getIkidClassDashboard(this.$route.query.Pud).then((res) => {
          this.datas = res;
          this.listclass = res.data
      });
    },

    loadData(options = {}) {
      const useEventGuard = options.useEventGuard !== false
      this.kid_class_id = this.listclass.find(item => item.name === this.ikid_class_name)?.id || 0

      var params ={
        page: this.current_page,
        per_page: this.per_page,
        sortby: this.sortBy,
        sortbydesc: this.sortByDesc ? 'DESC':'ASC',
        is_active: this.is_active,
        ikid_class_name: this.ikid_class_name,
        checkin_status: this.checkin_status,
        check_status: this.check_status,
        kid_class_id: this.kid_class_id
      }
      if (useEventGuard) {
        params.if_modified_since_event_id = this.lastEventId
      }
      ikid.getIkidClassDashboard(params).then((res) => {
          this.listclass = res.data
         });

      ikid.getIkidClassDataSource(params)
      .then(res => {
          if (res.not_changed) {
            this.lastEventId = res.event_id || this.lastEventId
            if (useEventGuard && (!this.rawItems || this.rawItems.length === 0)) {
              this.loadData({ useEventGuard: false })
              return
            }
            this.applyLocalFilters()
            return
          }

          this.lastEventId = res.event_id || this.lastEventId
          let getData = res.data
          this.rawItems = Array.isArray(getData.data) ? getData.data : []
          this.applyLocalFilters()
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      })

      ikid.getIkidClassDashboard(this.$route.query.Pud).then((res) => {
            this.datas = res;
      });


    },

    // to reload when pusher is triggered. to refresh the data
    loadDataKid() {
      this.kid_class_id = this.listclass.find(item => item.name === this.ikid_class_name)?.id || 0

      var params ={
        page: this.current_page,
        per_page: this.per_page,
        sortby: this.sortBy,
        sortbydesc: this.sortByDesc ? 'DESC':'ASC',
        is_active: this.is_active,
        ikid_class_name: this.ikid_class_name,
        checkin_status: this.checkin_status,
        check_status: this.check_status,
        kid_class_id: this.kid_class_id,
        if_modified_since_event_id: this.lastEventId
      }

      ikid.getIkidClassDataSource(params)
      .then(res => {
          if (res.not_changed) {
            this.lastEventId = res.event_id || this.lastEventId
            this.applyLocalFilters()
            return
          }

          this.lastEventId = res.event_id || this.lastEventId
          let getData = res.data
          this.rawItems = Array.isArray(getData.data) ? getData.data : []
          this.applyLocalFilters()
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      })
    },
    resolveStatusCode(item) {
      const numericStatus = Number(item && item.check_status)
      if (!Number.isNaN(numericStatus) && numericStatus > 0) {
        return numericStatus
      }

      const action = item && item.checkin_status && item.checkin_status.action
      if (action === 'check in') return 1
      if (action === 'in class') return 2
      if (action === 'queued') return 3
      if (action === 'check out') return 4
      return 0
    },
    applyLocalFilters() {
      let filtered = Array.isArray(this.rawItems) ? [...this.rawItems] : []

      if (this.search && this.search.trim() !== '') {
        const query = this.search.toLowerCase()
        filtered = filtered.filter(item => {
          const name = (item.name || '').toLowerCase()
          const className = (item.class_name || '').toLowerCase()
          return name.includes(query) || className.includes(query)
        })
      }

      if (this.ikid_class_name && this.ikid_class_name !== 0 && this.ikid_class_name !== '0') {
        const classFilter = String(this.ikid_class_name).toLowerCase()
        filtered = filtered.filter(item => String(item.class_name || '').toLowerCase() === classFilter)
      }

      const statusFilter = Number(this.checkin_status)
      if (!Number.isNaN(statusFilter) && statusFilter !== 0 && statusFilter !== 5) {
        filtered = filtered.filter(item => this.resolveStatusCode(item) === statusFilter)
      }

      filtered.sort((a, b) => {
        const timeA = a && a.checkin_status && a.checkin_status.log_time ? new Date(a.checkin_status.log_time).getTime() : 0
        const timeB = b && b.checkin_status && b.checkin_status.log_time ? new Date(b.checkin_status.log_time).getTime() : 0
        return timeB - timeA
      })

      this.items = filtered
      this.meta = {
          total: filtered.length,
          current_page: 1,
          per_page: this.per_page,
          from: filtered.length > 0 ? 1 : 0,
          to: filtered.length,
          is_active: this.is_active,
          ikid_class_name: this.ikid_class_name,
          checkin_status: this.checkin_status,
          check_status: this.check_status,
          kid_class_id: this.kid_class_id
      }
    },
    queueRealtimeRefresh(kidOnly = false) {
      this.refreshQueued = kidOnly ? 'kid' : 'full'
      this.flushRealtimeRefresh()
    },
    flushRealtimeRefresh() {
      if (!this.refreshQueued || this.refreshInFlight || this.refreshTimer) return
      const elapsed = Date.now() - this.refreshLastRunAt
      const waitMs = Math.max(0, this.refreshIntervalMs - elapsed)

      this.refreshTimer = setTimeout(async () => {
        this.refreshTimer = null
        if (!this.refreshQueued || this.refreshInFlight) return
        const mode = this.refreshQueued
        this.refreshQueued = false
        this.refreshInFlight = true
        this.refreshLastRunAt = Date.now()
        try {
          if (mode === 'kid') {
            await this.loadDataKid()
          } else {
            await this.loadData()
          }
        } finally {
          this.refreshInFlight = false
          if (this.refreshQueued) this.flushRealtimeRefresh()
        }
      }, waitMs)
    },
    openCheckOut: function(uuid) {
      // if(confirm("Do you really want to change?")){
        this.form.ikid_id = uuid;
        this.form.status = 4;
        ikid.changeStatusKidQueue(this.form)
        .then(res => {
        EventBus.$emit('TABLE_UPDATE_KIDS_CLASS_TEACHER', true)
          // var params = {title: 'Success', mode:'success', data:res.message}
          // EventBus.$emit('OPEN_MODAL_ALERT', params)

        }).catch ((err) => {
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      // }
    },
    getPhoto(data) {
       if (data) {
         return axios.defaults.baseURL + "/getfile/memberphoto/" + data.filename;
       } else {
         return axios.defaults.baseURL + "/getfile/memberphoto/no_photo.jpg";
       }
     },
     formatTime(logTime) {
      const date = new Date(logTime);
      return date.toLocaleTimeString('en-US', {
        hour12: false,
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      });
    },
    handlePerPage(val) {
        this.per_page = val
        this.loadData({ useEventGuard: false })
    },

    handlePagination(val) {
        this.current_page = val
        this.loadData({ useEventGuard: false })
    },

    handleSearch(val) {
        this.search = val
        this.current_page = 1
        this.applyLocalFilters()
    },

    handleSort(val) {
        this.sortBy = val.sortBy
        this.sortByDesc = val.sortDesc
        this.loadData({ useEventGuard: false })
    },

    handleIsActive(val) {
        this.is_active = val
        this.loadData({ useEventGuard: false })
    },

    handleStatus(val) {
        this.checkin_status = val
        this.loadData({ useEventGuard: false })
    },

    handleClassFilter(val) {
        this.ikid_class_name = val;
        this.meta.ikid_class_name = val;
        this.loadData({ useEventGuard: false })
    },

  }
}
</script>

<style scoped>

@media (max-width: 650px) {

  .card-set {
  position: relative;
  top: 6rem;
  }

}
</style>
